import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { IMarketingListToolFilter } from '@/components/content/MarketingListTool/interfaces/marketingListToolFilter.interface';
import ControlMulti, { IControlMultiItem } from '@/components/ui/ControlMulti';
import { getLayout } from '@/lib/helpers/getLayout';
import { LayoutType } from '@/components/content/MarketingListTool/GeneralFilter';

interface IProps {
  form: IMarketingListToolFilter;
  legalForms?: IControlMultiItem[];
  setForm: React.Dispatch<React.SetStateAction<IMarketingListToolFilter>>;
  toggleItem: (arr: string[], item: string) => string[];
  layout: LayoutType;
  mobileButtons?: React.ReactNode;
}

export const CompanyLegalForms = (props: IProps) => {
  const { form, legalForms, setForm, toggleItem, layout, mobileButtons } = props;
  const { t } = useTranslation();

  return (
    <ControlMulti
      id="companyLegalForms"
      placeholder={t('company.filter.legalForm')}
      values={form.companyLegalForms}
      options={legalForms || []}
      onChange={(value) => {
        setForm({
          ...form,
          companyLegalForms: toggleItem(form.companyLegalForms, value),
        });
      }}
      sameWidth={true}
      layout={getLayout(layout)}
      mobileButtons={mobileButtons}
    />
  );
};
